import { Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';

export const PreviewPulloutWrapper = styled.div`
	width: 75%;
	margin: auto;
	margin-bottom: 40px;
`;
PreviewPulloutWrapper.displayName = 'PreviewPulloutWrapper';

export const SurveyPreviewCallout = () => {
	return (
		<PreviewPulloutWrapper>
			<Pullout type={PulloutType.Note}>
				<b>{ContentConstants.CONFIRMSCHEDULE_PREVIEW_CALLOUT}</b> {ContentConstants.CONFIRMSCHEDULE_PREVIEW_CALLOUT_TEXT}
			</Pullout>
		</PreviewPulloutWrapper>
	);
};
